import React from 'react';
import {Editor} from '@tinymce/tinymce-react';
import {useAppState} from "store/module/app.store";
import FileManagementApi from 'api/file-management.api'

function FormHtmlEditor({value, onChange, height = 300, minimum = false}) {
    const {theme} = useAppState();
    let toolbar = [
        'undo redo | bold italic underline | template save insertdatetime | alignleft aligncenter alignright alignjustify hr | bullist numlist outdent indent | styleselect | responsivefilemanager | link unlink anchor | file image media  | forecolor backcolor  | print preview code | emoticons charmap | fullscreen'
    ];

    if (minimum) {
        toolbar = [
            'undo redo | bold italic underline | alignleft aligncenter alignright alignjustify hr | bullist numlist outdent indent | link unlink | fullscreen'
        ]
    }

    const config = {
        height,
        menubar: false,
        automatic_uploads: true,
        images_upload_url: process.env.REACT_APP_API_URL + FileManagementApi.photoEditorUpload,
        plugins: [
            'advlist',
            'autolink',
            'noneditable',
            'link',
            'image',
            'charmap',
            'emoticons',
            'hr',
            'insertdatetime',
            'template',
            'save',
            'charmap',
            'print',
            'preview',
            'anchor',
            'pagebreak',
            'searchreplace',
            'wordcount',
            'visualblocks',
            'visualchars',
            'insertdatetime',
            'media',
            'nonbreaking',
            'table',
            'directionality',
            'emoticons',
            'paste',
            'code',
            'fullscreen'
        ],
        style_formats: [
            { title: "H1", block: "h1" },
            { title: "H2", block: "h2" },
            { title: "H3", block: "h3" },
            { title: "H4", block: "h4" },
            { title: "H5", block: "h5" },
            { title: "H6", block: "h6" },
            { title: "Paragraph", block: "p" },
        ],
        toolbar,
        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
    }

    if (theme === 'dark') {
        config.content_css = 'dark';
        config.skin = 'oxide-dark'
    }

    return (
        <Editor
            apiKey="08lj4fdcdjlblc4mga09vdo2ni2n99e9kgoa0yuy2yhpgcqu"
            initialValue={value}
            onEditorChange={e => onChange(e)}
            init={config}
        />
    );
}

export default FormHtmlEditor;
